import CowsApi from "../../../api/cows-api";
import { mapState, mapActions } from "vuex";
import i18n from "../../../plugins/i18n";
import UtilsService from '../../../services/UtilsService';

export default {
  name: "EditCowModal",

  props: { cow: Object, isModalOpen: Boolean, reload: Function },

  data() {
    return {
      date: this.$moment(),
      maxDate: this.$moment(),

      requestLoading: false,

      name: null,
      fullEartag: null,
      breed: null,
      lactationNumber: null,
      selectedBarn: null,
      selectedBolus: null,
      isArchived: null,

      errors: {},
      serverError: null
    };
  },
  computed: {
    ...mapState({
      boluses(state) {
        return [{ text: "Remove bolus", value: null }, ...state.boluses.boluses.map(d => ({
            value: d.bolus_id,
            text: d.bolus_name
        }))];
      },
      barns(state) {
        return state.buildings.data.map(d => {
          return {
            value: d.building_id,
            text: d.building_name
          };
        });
      }
    }),
    formattedDate() {
      return this.date ? this.$moment(this.date).format('DD-MM-YYYY') : '';
    },
  },
  methods: {
    ...mapActions("boluses", {
      clearBoluses: "clear",
      listBoluses: "listBoluses"
    }),
    ...mapActions("buildings", {
      clearBuildings: "clear",
      getBarns: "getBuildings"
    }),
    flushErrors() {
      this.serverError = null;
      this.errors = {};
    },
    validate() {
      this.flushErrors();

      if (this.name === null || this.name === "") {
        this.errors.name = i18n.t("editCow.errors.fieldRequired");
      }

      if (this.selectedBarn === null) {
        this.errors.barn = i18n.t("editCow.errors.barnRequired");
      }

      if (Object.keys(this.errors).length > 0) {
        return false;
      }
      return true;
    },
    async save() {
      // Validate form data before save
      const isValidForm = this.validate();
      if (!isValidForm) return;

      // Define the data to send
      const dataToSend = {
        ...(this.name !== this.cow.eartag && { eartag: this.name }),
        ...(this.fullEartag !== this.cow.full_eartag && { full_eartag: this.fullEartag }),
        ...(this.breed !== this.cow.breed && { breed: this.breed }),
        ...(this.lactationNumber !== this.cow.lactation_number && {
          lactation_number: parseInt(this.lactationNumber)
        }),
        ...(this.selectedBarn !== this.cow.building_id && {
          building_id: this.selectedBarn
        }),
        ...(this.selectedBolus !== this.cow.bolus_id && {
          bolus_id: this.selectedBolus
        }),
        ...(this.date !== this.cow.birth_date && {
          birth_date: UtilsService.getDate(new Date(this.date))
        }),
        ...(this.isArchived &&
          !this.cow.archived_at && {
          archived_at: new Date()
        }),
        ...(!this.isArchived &&
          !!this.cow.archived_at && {
          archived_at: null
        })
      };

      this.requestLoading = true;

      // Set loading and wait for data to be sent and response to be returned.
      const response = await CowsApi.editCow(this.cow.cow_id, { ...dataToSend });

      this.requestLoading = false;

      if (response.status == 200) {
        this.reload();
        this.close();
      } else {
        this.serverError = {
          error: response.data,
          message: response.data
        };
      }
    },
    close() {
      this.$emit("close");
    }
  },
  mounted() {
    this.listBoluses({ available_only: true, bolus_exception: this.cow.bolus_id });
    this.getBarns();
    this.name = this.cow.eartag;
    this.fullEartag = this.cow.full_eartag;
    this.breed = this.cow.breed;
    this.lactationNumber = this.cow.lactation_number;
    this.selectedBarn = this.cow.building_id;
    this.selectedBolus = this.cow.bolus_id;
    this.date = this.cow.birth_date;
    this.isArchived = this.cow.archived_at ? true : false;
  }
};



// WEBPACK FOOTER //
// ./src/components/_modals/edit-cow/edit-cow-modal.js